/* 

These are all the known tracking ID's from analytics. Although they are not used completely, i would 
like to leave these in here for future tracking calls

*/

export enum PageTypeTrackingId {
  blogArticle = "webpageBlogArticle",
  contentCanvas = "webpageContentCanvas",
  formGroups = "formGroups",
  formPrivacyRequest = "formPrivacyRequest",
  formSales = "formSales",
  societyMCity = "societyMCity",
  societyMContent = "societyMContent",
  societyMProperty = "societyMProperty",
  webpageAppAddons = "webpageAppAddons",
  webpageAppDetails = "webpageAppDetails",
  webpageAppMembershipDetails = "webpageAppMembershipDetails",
  webpageAppMembershipPayment = "webpageAppMembershipPayment",
  webpageAppPayment = "webpageAppPayment",
  webpageAppRates = "webpageAppRates",
  webpageBlogArticle = "webpageBlogArticle",
  webpageBookingEngineAddons = "webpageBookingEngineAddons",
  webpageBookingEngineConfirmation = "webpageBookingEngineConfirmation",
  webpageBookingEngineDetails = "webpageBookingEngineDetails",
  webpageBookingEnginePayment = "webpageBookingEnginePayment",
  webpageBookingEngineRates = "webpageBookingEngineRates",
  webpageCity = "webpageCity",
  webpageContent = "webpageContent",
  webpageContinent = "webpageContinent",
  webpageCorporateBookingPage = "webpageCorporateBookingPage",
  webpageFaq = "webpageFaq",
  webpageForgotPassword = "webpageForgotPassword",
  webpageGroupReservation = "webpageGroupReservation",
  webpageHomepage = "webpageHomepage",
  webpageHotelProperty = "webpageHotelProperty",
  webpageLegal = "webpageLegal",
  webpageLogin = "webpageLogin",
  webpageMemberShipPayment = "webpageMemberShipPayment",
  webpageMemberShipPurchase = "webpageMemberShipPurchase",
  webpageMyBooking = "webpageMyBooking",
  webpageMyBookingNumberLogin = "webpageMyBookingNumberLogin",
  webpageMyBookingReservation = "webpageMyBookingReservation",
  webpageMyBookingReservationPayment = "webpageMyBookingReservationPayment",
  webpageMyBookingReservations = "webpageMyBookingReservations",
  webpageMycitizenMBooking = "webpageMycitizenMBooking",
  webpageMycitizenMDashboard = "webpageMycitizenMDashboard",
  webpageMycitizenMMembership = "webpageMycitizenMMembership",
  webpageMycitizenMProfile = "webpageMycitizenMProfile",
  webpageMycitizenMReservation = "webpageMycitizenMReservation",
  webpageMycitizenMReservationPayment = "webpageMycitizenMReservationPayment",
  webpageMycitizenMReservations = "webpageMycitizenMReservations",
  webpagePasswordReset = "webpagePasswordReset",
  webpageRegister = "webpageRegister",
  webpageSocietyMMeetingRooms = "webpageSocietyMMeetingRooms",
  webpageThankYou = "webpageThankYou",
}

export interface ContentfulPageComposableOptions {
  /**
   * Setting this value to "true" will trigger the page to set SEO meta tags based on page response.
   *
   * @default undefined
   */
  setSeoMeta: boolean;
  /**
   * Providing a value will trigger cmtr to track a page info event
   *
   * @default undefined
   */
  pageTypeToTrack: PageTypeTrackingId;
  /**
   * Providing a value will trigger cmtr to track a page info event with the given ecommerce stage. Defaults to "none"
   */
  ecommerceStage?: string;
}
